import { request } from '@/utils/request';
/**
 * 支行列表
 * @param {*} data
 * @returns
 */
export async function getSubBankList(data) {
  return request('/zlb/api/pay/bankCard/bank/branch/db-list', {
    data,
    method: 'POST',
  });
}
/**
 * 查询浙商银行列表
 * @param {*} params
 * @returns
 */
export async function getZSBankList(params) {
  return request('/zlb/api/pay/bankCard/zs-bank/list', {
    params,
    method: 'GET',
  });
}

/**
 * 查询浙商支行列表
 * @param {*} data
 * @returns
 */
export async function getZSSubBankList(data) {
  return request('/zlb/api/pay/bankCard/zs-bank/branch/list', {
    data,
    method: 'POST',
  });
}

/**
 * 新增/编辑大行
 * @param {*} data
 * @returns
 */
export async function saveMainBank(data) {
  return request('/zlb/api/pay/bankCard/bank/personal/save-or-update', {
    data,
    method: 'POST',
  });
}
/**
 * 新增/编辑支行
 * @param {*} data
 * @returns
 */
export async function saveSubBank(data) {
  return request('/zlb/api/pay/bankCard/bank/branch/save-or-update', {
    data,
    method: 'POST',
  });
}

/**
 * 查询银行行号
 * @param {*} data
 * @returns
 */
export async function queryBankCode(data) {
  return request('/zlb/api/pay/bankCard/official/unbind', {
    data,
    method: 'POST',
  });
}
/**
 * 删除银行信息
 * @param {*} data
 * @returns
 */
export async function deleteBankInfo(data) {
  return request('/zlb/api/pay/bankCard/bank/personal/delete', {
    data,
    method: 'POST',
  });
}
/**
 * 删除支行信息
 * @param {*} data
 * @returns
 */
export async function deleteSubBankInfo(data) {
  return request('/zlb/api/pay/bankCard/bank/branch/delete', {
    data,
    method: 'POST',
  });
}
